<template>
  <div id="footer">
    <div id="container">
      <div id="footer-container">
        <div id="footer-social-container">
          <h2>Social</h2>
          <ul id="footer-social-list">
            <li v-for="socialMedia in contacts.socialMedias" :key="socialMedia.nome">
              <a class="footer-social-link" :href="socialMedia.url" target="_blank">
                <font-awesome-icon :icon="socialMedia.icon"></font-awesome-icon>
              </a>
            </li>
          </ul>
        </div>
        <div id="footer-contact-container">
          <h2>Contatos</h2>
          <a id="contacts-email" :href="'mailto:' + contacts.email" class="footer-contacts-link">
            <p>{{ contacts.email }}</p>
          </a>
          <a :href="'tel:' + contacts.phone" :key="contacts.phone" class="footer-contacts-link">
            <p>{{ contacts.phone }}</p>
          </a>
        </div>
        <div id="footer-address-container">
          <h2>Endereço</h2>
          <p>{{address}}</p>
        </div>
      </div>
      <h2 id="footer-copyright">
        2019 - 2021 -
        <strong class="montserrat-500">exception jr</strong> - desenvolvimento de
        software
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheFooter",
  data() {
    return {};
  },
  computed: {
    contacts() {
      return this.$store.state.contacts;
    },
    address() {
      return this.$store.state.address;
    }
  }
};
</script>

<style scoped lang="scss">
#footer {
  top: 110px;
  // @include for-tablet-portraid-up {
  //   top: 150px;
  // }
  // left: 0;
  position: relative;
  // background: $degrade-exception;
  background: $verde-exception;
  display: flex;
  align-items: center;
  justify-content: center;
}

#container {
  width: 90vw;
}

#footer-container {
  // padding: 10px 30px;
  margin-top: 20px;
  display: grid;
  color: #fff;
  text-align: center;

  @include for-tablet-portraid-up() {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 20px;
    text-align: left;
  }

  h2 {
    font-size: 1.5rem;
    margin: 10px 0 10px 0;
    @include for-tablet-portraid-up {
      font-size: 16px;
    }
    @include for-tablet-portraid-up {
      font-size: 1.5rem;
    }
  }
  p {
    margin: 5px 0;
    @include for-tablet-portraid-up {
      font-size: 14px;
    }
    @include for-tablet-landscape-up {
      font-size: 1rem;
    }
  }
}

#footer-social-list {
  font-size: 1.5rem;
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  font-size: 2rem;

  @include for-tablet-portraid-up() {
    justify-content: flex-start;
  }
}
.footer-social-link {
  padding: 5px;
  color: #fff;
}

#footer-contacts-container {
  display: flex;
  flex-direction: column;

  @include for-tablet-portraid-up() {
    font-size: 1rem;
    text-align: left;
  }
}

.footer-contacts-link {
  padding-bottom: 5px;
  text-decoration: none;
  color: white;
}

.montserrat-500 {
  font-weight: 500;
}
#footer-copyright {
  font-size: 0.7rem;
  font-weight: 400;
  text-align: center;
  margin: 0;
  padding-bottom: 15px;
  color: #fff;
}
</style>
